import React from "react";
import Input from "antd/lib/input";
import { useTheme } from "@/components/ThemeProvider";

export default function InputField({ form, field, ...otherProps }) {
  const { isDarkMode } = useTheme();
  return <Input {...otherProps} className={isDarkMode ? "dark-mode" : ""} />;
}
